(function () {
  var root = document.querySelector("[data-cjet-plp]");
  if (!root) return;

  var snize =
    document.querySelector(".snize-search-form, .snize-input-style, [class*='snize']") ||
    window.Searchanise ||
    window.searchanise;

  function more() {
    var trigger = root.querySelector("[data-cjet-plp-more]");
    if (!trigger) return;
    trigger.addEventListener("click", function () {
      var href = trigger.getAttribute("href");
      if (!href) return;
      try {
        var url = new URL(href, window.location.origin);
        if (url.searchParams.get("page")) {
          history.replaceState({ page: url.searchParams.get("page") }, "", url.pathname + url.search);
        }
      } catch (e) {}
    });
  }

  function predict() {
    if (snize) return;
    var form = root.querySelector("[data-cjet-plp-search]");
    var input = root.querySelector("[data-cjet-plp-q]");
    var box = root.querySelector("[data-cjet-plp-predict]");
    if (!form || !input || !box) return;
    var timer = 0;
    var ctrl = null;

    function hide() {
      box.hidden = true;
      box.innerHTML = "";
    }

    function draw(data) {
      var html = "";
      var resources = (data && data.resources && data.resources.results) || {};
      var products = resources.products || [];
      var collections = resources.collections || [];
      var queries = resources.queries || [];
      var brands = collections.filter(function (c) {
        return c && c.url && /cjet-brand-/.test(c.url);
      });
      var cols = collections.filter(function (c) {
        return c && c.url && !/cjet-brand-/.test(c.url);
      });
      if (queries.length) {
        html += "<h3>Suggestions</h3>";
        queries.forEach(function (q) {
          html += '<a href="' + q.url + '">' + (q.text || q.styled_text || "") + "</a>";
        });
      }
      if (products.length) {
        html += "<h3>Products</h3>";
        products.forEach(function (p) {
          html += '<a href="' + p.url + '">' + (p.title || "") + "</a>";
        });
      }
      if (brands.length) {
        html += "<h3>Brands</h3>";
        brands.forEach(function (c) {
          html += '<a href="' + c.url + '">' + (c.title || "") + "</a>";
        });
      }
      if (cols.length) {
        html += "<h3>Collections</h3>";
        cols.forEach(function (c) {
          html += '<a href="' + c.url + '">' + (c.title || "") + "</a>";
        });
      }
      box.innerHTML = html;
      box.hidden = !html;
    }

    input.addEventListener("input", function () {
      var q = input.value.trim();
      window.clearTimeout(timer);
      if (q.length < 2) {
        hide();
        return;
      }
      timer = window.setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        var url =
          "/search/suggest.json?q=" +
          encodeURIComponent(q) +
          "&resources[type]=product,collection,query&resources[limit]=5";
        fetch(url, { signal: ctrl.signal })
          .then(function (r) {
            return r.json();
          })
          .then(draw)
          .catch(function () {});
      }, 180);
    });

    input.addEventListener("keydown", function (e) {
      if (e.key === "Escape") hide();
    });
    document.addEventListener("click", function (e) {
      if (!box.contains(e.target) && e.target !== input) hide();
    });
  }

  function park() {
    var facets = document.querySelector("[data-cjet-plp-facets]");
    var slot = document.querySelector("[data-cjet-plp-facet-slot]");
    var home = document.querySelector("[data-cjet-plp-facet-home]");
    if (!facets || !slot || !home) return;
    var mobile = window.matchMedia("(max-width: 749px)").matches;
    if (mobile) {
      if (facets.parentNode !== slot) slot.appendChild(facets);
    } else if (facets.parentNode !== home) {
      home.appendChild(facets);
      var drawer = document.querySelector('[data-cjet-drawer-id="cjet-plp-filters"]');
      if (drawer && window.cjetDrawer) window.cjetDrawer.close(drawer);
    }
  }

  function scroll() {
    var key = "cjet-plp-y";
    try {
      var y = sessionStorage.getItem(key);
      if (y != null) {
        sessionStorage.removeItem(key);
        window.requestAnimationFrame(function () {
          window.scrollTo(0, parseInt(y, 10) || 0);
        });
      }
    } catch (e) {}
    root.addEventListener("click", function (e) {
      var a = e.target.closest("[data-cjet-plp-facets] a, [data-cjet-plp-chips] a");
      if (!a) return;
      try {
        sessionStorage.setItem(key, String(window.scrollY));
      } catch (err) {}
    });
  }

  function brands() {
    var wrap = root.querySelector("[data-cjet-plp-brand-q]");
    if (!wrap) return;
    var input = wrap.querySelector("input");
    var list = root.querySelector("[data-cjet-plp-brands]");
    if (!input || !list) return;
    input.addEventListener("input", function () {
      var q = input.value.trim().toLowerCase();
      list.querySelectorAll("[data-cjet-plp-facet]").forEach(function (li) {
        li.hidden = !!(q && li.textContent.toLowerCase().indexOf(q) === -1);
      });
    });
  }

  function intro() {
    document.addEventListener("click", function (e) {
      var a = e.target.closest("[data-cjet-plp-intro]");
      if (!a) return;
      var target = document.getElementById("cjet-collection-copy");
      if (!target) return;
      e.preventDefault();
      if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: "start" });
    });
  }

  function hideFilters() {
    var btn = root.querySelector("[data-sidebar-toggle]");
    if (!btn) return;

    function apply() {
      var off = root.getAttribute("data-cjet-filters") === "off";
      btn.setAttribute("aria-expanded", off ? "false" : "true");
      var aside = root.querySelector("[data-cjet-plp-facet-home]");
      if (aside) {
        if (off) aside.setAttribute("hidden", "");
        else aside.removeAttribute("hidden");
      }
    }

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var off = root.getAttribute("data-cjet-filters") !== "off";
      root.setAttribute("data-cjet-filters", off ? "off" : "on");
      apply();
    });
    apply();
  }

  function boot() {
    more();
    predict();
    brands();
    intro();
  }

  root.setAttribute("data-cjet-plp-ready", "1");
  park();
  hideFilters();
  scroll();
  window.addEventListener("resize", park);

  if ("requestIdleCallback" in window) {
    requestIdleCallback(boot, { timeout: 1200 });
  } else {
    window.setTimeout(boot, 200);
  }
})();
